import React from 'react';

import { SelectListFilter } from '@sandtech-hub-monorepo/ui-kit';
import { useGeoPicker } from './picker';

export const StatePicker = ({
  countryCode,
  selected,
  handleOnSelect,
}: {
  countryCode?: string;
  selected?: string;
  handleOnSelect?: (item: { value: string; label: string }) => void;
}) => {
  const { getStates } = useGeoPicker();

  return (
    <SelectListFilter
      items={countryCode ? getStates(countryCode) : undefined}
      defaultValue={selected}
      handleChange={handleOnSelect}
    />
  );
};
